module.exports = __webpack_public_path__ + "img/Sylva_island_raw.aa2de0fc.png";